import { ITag } from "@fluentui/react/lib/Pickers";
import { IAgreementForm } from "./agreements";

export interface IPolicyPanelInfo {
  editState: PolicyEditState;
  policyId?: string;
}

export interface IPolicyFormsInfo {
  policyId: string | undefined;
  propertiesForm: IModifiablePolicyProperties | undefined;
  isSubmitting: boolean;
}

export interface IModifiablePolicyProperties {
  name?: string;
  description?: string;
  template?: string;
  tags?: ITag[];
}

export interface IPolicyPropertiesForm extends IAgreementForm {
  properties: IModifiablePolicyProperties;
}

export interface IPolicyPropertiesFormUpdatePayload extends IAgreementForm {
  properties?: Partial<IModifiablePolicyProperties>;
}

export interface IPolicyFormInitializationInfo {
  policyInfo: any; // Will be defined later when we have the full policy model
  editState: PolicyEditState;
}

export enum PolicyEditState {
  NewPolicy = "NewPolicy",
  Default = "Default"
}